import { AuthContext, IAuthContextProps } from '@enter/core';
import { PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';
import * as S from '../app.styles';

export class Expired extends React.PureComponent {
    public static contextType = AuthContext;
    public render(): React.ReactElement {
        return (
            <S.Section>
                <PageLayout>
                    <PageLayoutRow>
                        <PageLayoutHeader>
                            <PageLayoutTitle>Session Expired</PageLayoutTitle>
                        </PageLayoutHeader>
                    </PageLayoutRow>
                    <PageLayoutRow>
                        Your session has expired due to inactivity. Please login again.
                        <S.Button onClick={this.handleClick}>Login</S.Button>
                    </PageLayoutRow>
                </PageLayout>
            </S.Section>
        );
    }
    private readonly handleClick = (): void => {
        // NB: redirect to the dashboard, not back to this page
        this.context &&
            (this.context as any).logoutAndRedirect(new Map([
                ['redirect_uri', window.location.origin],
            ]));
    };
}
